import styled from 'styled-components'

export const ShowcaseOuter = styled.section`
  background-color: ${({ theme }) =>
    theme.colors.showcaseBg ? theme.colors.showcaseBg : 'white'};
  > * {
    background-color: ${({ theme }) =>
      theme.colors.showcaseBg ? theme.colors.showcaseBg : 'white'};
  }
`

export const ShowcaseWrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  padding-bottom: 9rem;
  padding-left: 21px;
  padding-right: 21px;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  justify-content: center;
  align-items: flex-start;
  background-color: ${({ theme }) =>
    theme.colors.showcaseBg ? theme.colors.showcaseBg : 'white'};
  @media only screen and (max-width: 900px) {
    flex-direction: column;
  }
`

export const ShowcaseCard = styled.div`
  flex: 1;
  margin: 0 auto;
  box-sizing: border-box;
  max-width: 310px;
  .para {
    font-size: 21px;
    max-width: 310px;
    line-height: 1.3;
    margin-bottom: 2rem;
    margin-right: 0px;
    margin-left: 0px;
  }
  @media only screen and (max-width: 1200px) {
    flex: 1;
    max-width: 300px;
  }
  @media only screen and (max-width: 1000px) {
    flex: 1;
    max-width: 290px;
  }
  @media only screen and (max-width: 900px) {
    width: 100%;
    padding-bottom: 6rem;
    &:last-child {
      padding-bottom: 0;
    }
  }
`

export const CardUpper = styled.div`
  padding: 3.3rem 0 2rem 0;
  .name {
    line-height: 25px;
    font-size: 30px;
    font-weight: 600;
    padding-bottom: 0.8rem;
    color: black;
  }
  > p {
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey1};
  }
`

export const CardOptions = styled.ul`
  font-size: 1.5rem;
  line-height: 2rem;
  list-style-type: decimal;
  .help {
    font-weight: 500;
  }
  > li {
    margin-left: 1.3rem;
    font-weight: 400;
    font-size: 21px;
    margin-bottom: 8px;
  }
`

export const Text = styled.div`
  @media only screen and (min-width: 880px) {
    min-height: ${({ textMin }) => (textMin ? textMin : 'auto')};
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
`

export const IconsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 300px;
  align-items: center;
  min-height: 45px;

  > svg {
    max-height: 50px;
    ${({ isGrayed }) => isGrayed && 'filter: grayscale(100%)'};
    &:first-child {
      padding-right: 12px;
    }
    &:nth-child(2) {
      padding-left: 12px;
    }
  }

  .alamos-icon {
    margin-top: -20px;
  }
`
